module.exports = __webpack_public_path__ + "static/search-area-9f0cdd3916aba856c7e69936b2303f02.png";